'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CheckboxGroup: ()=>CheckboxGroup
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const checkbox_group_namespaceObject = require("@base-ui-components/react/checkbox-group");
const CheckboxWithLabel_cjs_namespaceObject = require("../CheckboxWithLabel/CheckboxWithLabel.cjs");
const external_CheckboxGroup_variants_cjs_namespaceObject = require("./CheckboxGroup.variants.cjs");
const index_cjs_namespaceObject = require("../../Collapsible/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
function CheckboxGroup({ isCollapsible, options, className, handleChange, triggerClassName, layout, ...props }) {
    const { checkboxGroup } = (0, external_CheckboxGroup_variants_cjs_namespaceObject.checkboxGroupVariants)({
        layout
    });
    const classes = (0, external_utils_index_cjs_namespaceObject.cn)(checkboxGroup(), className);
    const onChange = (_value, event)=>{
        handleChange?.(event?.target?.value, event);
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(checkbox_group_namespaceObject.CheckboxGroup, {
        className: classes,
        ...props,
        children: isCollapsible && options.length > 1 ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Collapsible, {
            className: "w-full",
            heading: /*#__PURE__*/ (0, external_react_namespaceObject.createElement)(CheckboxWithLabel_cjs_namespaceObject.CheckboxWithLabel, {
                ...options[0],
                key: options[0].value,
                handleChange: onChange,
                isCheckboxGroup: true
            }),
            triggerClassName: triggerClassName,
            triggerPadding: "0",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
                children: options.map((option, idx)=>idx > 0 ? /*#__PURE__*/ (0, external_react_namespaceObject.createElement)(CheckboxWithLabel_cjs_namespaceObject.CheckboxWithLabel, {
                        ...option,
                        key: option.value,
                        handleChange: onChange,
                        isCheckboxGroup: true
                    }) : null)
            })
        }) : options.map((option)=>/*#__PURE__*/ (0, external_react_namespaceObject.createElement)(CheckboxWithLabel_cjs_namespaceObject.CheckboxWithLabel, {
                ...option,
                key: option.value,
                handleChange: onChange,
                isCheckboxGroup: true,
                layout: layout
            }))
    });
}
exports.CheckboxGroup = __webpack_exports__.CheckboxGroup;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CheckboxGroup"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
